export default __webpack_public_path__ + "static/media/Feature3.830e57f5.svg";